/**
 * Public shell: marketing home + sign-in surface.
 *
 * Mirrors the cream marketing background from the old Next.js
 * ``app/(auth)/layout.tsx`` and lets each child route own its own
 * composition (split, centered, hero etc.). Wrapped in `AuthProvider`
 * with `initial=null` so descendants can still call `useAuth()` —
 * `state` will simply be null on this surface.
 */

import { Outlet } from "react-router-dom";

import { AuthProvider } from "../lib/auth";

export function PublicShell() {
  return (
    <AuthProvider state={null}>
      <Outlet />
    </AuthProvider>
  );
}
